module.exports = [{
      plugin: require('D:/Sources/orbis-linguarum/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
